/**
 * 操作员管理页面
 * 创建时间：2017-03-23
 * 创建人：masonchen
 */
<template>
	<div class="wrapper-content tabBox" id="operator" v-loading="loadingstatus" element-loading-text="加载中">
		<div class="float-e-margins ibox-content animated fadeInRight">
			<div class="row">
				<div class="form-horizontal">
					<div class="col-sm-3 gray_right02 h100pp">
						<div class="form-group">
							<label class="col-sm-3 control-label">操作员</label>
							<div class="col-sm-9 text-left">									
								<button v-if="permission.indexOf('operator_add') == -1"  @click="create" class="btn btn-primary white" :disabled="enableCreate||isAdmin<=0">新建</button>
								<button v-if="permission.indexOf('operator_accountDelete') == -1"  @click="openModal('modal2')" class="btn btn-primary white" :disabled="enableDelete||isAdmin<=0">删除</button>
							</div>                                                                  
						</div>
						<div class="ibox-content" style="overflow: auto;height: calc(100% - 70px);">
							<input type="text" class="form-control" placeholder="请输入要查询的帐号名称" v-model="queryAccount"/>
							<ul v-show="!isEmty" id="operator-tree" class="ztree"></ul>
							<p v-show="isEmty">没有匹配结果 "{{errorVal}}"</p>
						</div>
					</div>
					<div class="col-sm-9 gray_left02 h100pp">
						<div class="form-horizontal">
							<div class="form-group">
								<label class="col-sm-1 control-label">操作员所属机构</label>
								<div class="col-sm-3">
									<input class="form-control" type="text" v-model="userInfo.customer_name" readonly>
								</div>
								<label class="col-sm-1 control-label">机构英文简称</label>
								<div class="col-sm-3">
									<input class="form-control" type="text" v-model="userInfo.customer_short_name" readonly>
								</div>
								<label class="col-sm-1 control-label">是否管理员</label>
								<div class="col-sm-3">
									<input class="form-control" type="text" v-model="userInfo.isAdmin" readonly>
								</div>
								
								<!--<div v-if="enableCreate" class="col-sm-4 text-right">
									<button v-if="permission.indexOf('operator_resetPassword') == -1" class="btn btn-primary" @click="mailboxReset()">通过邮箱重置密码</button>
								</div>-->
							</div>
							<br />
							<div class="form-group">
								<label class="col-sm-1 control-label"><span class="red">*帐号</span></label>
								<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.userInfo.account.$error }">
									<div class="input-group">
										<input class="form-control" type="text" v-model.trim="userInfo.account"  @input="$v.userInfo.account.$touch()" maxlength="20" minlength="6">
										<div class="input-group-addon">@{{userInfo.customer_short_name}}</div>
									</div>
									<span class="form-group__message cus_message" v-if="!$v.userInfo.name.required && $v.userInfo.account.$error">必填</span>
								</div>
								<label class="col-sm-1 control-label"><span :class="isEditOrCreate?'red':''">*密码</span></label>
								<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.userInfo.password.$error }" style="position: relative;">
									<input type="password" class="form-control" v-model.trim="userInfo.password" @input="$v.userInfo.password.$touch()">
									<span class="form-group__message cus_message" v-if="!$v.userInfo.password.required && $v.userInfo.password.$error && isEditOrCreate">必填</span>
									<span class="form-group__message cus_message" v-if="!$v.userInfo.password.maxLength || !$v.userInfo.password.minLength">长度在6~30之间</span>
								</div>
								<label class="col-sm-1 control-label"><span :class="isEditOrCreate?'red':''">*再次输入密码</span></label>
								<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.userInfo.passwordConfirm.$error }" style="position: relative;">
									<input type="password" class="form-control" v-model.trim="userInfo.passwordConfirm" @input="$v.userInfo.passwordConfirm.$touch()">
									<!--<span class="form-group__message cus_message" v-if="!$v.userInfo.passwordConfirm.required && $v.userInfo.passwordConfirm.$error">必填</span>-->
									<span class="form-group__message cus_message" v-if="!$v.userInfo.passwordConfirm.sameAsPassword && $v.userInfo.passwordConfirm.$error">两次密码不一致</span>
								</div>
							</div>
							<div class="form-group">
								<label class="col-sm-1 control-label"><span class="red">*姓名</span></label>
								<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.userInfo.name.$error }">
									<input class="form-control" type="text" v-model.trim="userInfo.name"  @input="$v.userInfo.name.$touch()" maxlength="20">
									<span class="form-group__message cus_message" v-if="!$v.userInfo.name.required && $v.userInfo.name.$error">姓名为必填项</span>
								</div>
								<label class="col-sm-1 control-label"><span class="red">*顺序号</span></label>
								<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.userInfo.orderno.$error }" style="position: relative;">
									<input type="number" class="form-control" v-model.trim="userInfo.orderno" @input="$v.userInfo.orderno.$touch()">
									<span class="form-group__message cus_message" v-if="!$v.userInfo.orderno.required && $v.userInfo.orderno.$error">顺序号为必填项</span>
									<span class="form-group__message cus_message" v-if="!$v.userInfo.orderno.between">必须在 {{$v.userInfo.orderno.$params.between.min}} 和 {{$v.userInfo.orderno.$params.between.max}} 之间</span>
								</div>
								<label class="col-sm-1 control-label"><span class="red">*状态</span></label>
								<div class="col-sm-3">
									<select class="form-control" v-model="userInfo.isenable">
										<option v-for="(item, index) in orgStatusInfo" v-bind:value="item.value">{{ item.name }}</option>
									</select>
								</div>
							</div>
							<div class="form-group">
								<label class="col-sm-1 control-label">职务</label>
								<div class="col-sm-3">
									<input class="form-control" type="text" v-model.trim="userInfo.job" maxlength="20">
								</div>
								<label class="col-sm-1 control-label">电话</label>
								<div class="col-sm-3">
									<input type="text" class="form-control" v-model.trim="userInfo.mobile" maxlength="11">
								</div>
								<!--<label class="col-sm-1 control-label"><span class="red">邮箱</span></label>
								<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.userInfo.account.$error }">
									<input type="text" class="form-control" v-model.trim="userInfo.account" @input="$v.userInfo.account.$touch()" maxlength="50" v-if="!enableCreate">
									<input type="text" class="form-control" v-model.trim="userInfo.account" @input="$v.userInfo.account.$touch()" maxlength="50" v-if="enableCreate" readonly>
									<span class="form-group__message cus_message" v-if="!$v.userInfo.account.required && $v.userInfo.account.$error">邮箱为必填项</span>
									<span class="form-group__message cus_message" v-if="!$v.userInfo.account.email && $v.userInfo.account.$error">邮箱格式不正确</span>
								</div>-->
							</div>
							<!--<div class="form-group">
								<span class="col-sm-offset-1 red" v-if="normalMail && $v.userInfo.account.email && $v.userInfo.account.required">为确保您能正常接收邮件，请将邮箱（ op_support@didi-gps.com）加入您的邮箱白名单</span>
								<a class="col-sm-offset-1 red" v-if="!normalMail && $v.userInfo.account.email && $v.userInfo.account.required" :href="mailLink" target="_blank" style="text-decoration: underline;">为确保您能正常接收邮件，请点击将邮箱（ op_support@didi-gps.com）加入白名单</a>
	
							</div>-->
							<div class="form-group">
								<label class="col-sm-1 text-right control-label">备注</label>
								<div class="col-sm-11" v-bind:class="{ 'form-group--error': $v.userInfo.memo.$error }" @input="$v.userInfo.memo.$touch()">
									<textarea class="form-control" rows="4" v-model.trim="userInfo.memo"></textarea>
									<span class="form-group__message cus_message" v-if="!$v.userInfo.memo.maxLength">不得超过300字</span>
								</div>
							</div>
						</div>
						<!--<div method="get" class="form-horizontal mt20px" v-if="userInfo.isAdmin=='是'">
							<label class=" pt20px col-sm-12  control-label t_left">当前用户为管理员用户</label>
						</div>-->
						<div method="get" class="form-horizontal mt20px" v-if="userInfo.isAdmin!='是'">
							<div class="form-group  text-left">
								<label class=" pt20px col-sm-6  control-label t_left">所属权限组</label>
								<div class="col-sm-6 text-right" >
									<button v-if="permission.indexOf('operator_addRole') == -1" :disabled="isAdmin<1" @click="addAuthorization" class="btn btn-primary mr10px  " type="submit">添加权限组</button>
									<button v-if="permission.indexOf('operator_roleOpen') == -1" :disabled="isAdmin<1" @click="goTab" class="btn btn-primary" type="submit">打开权限组管理</button>
								</div>
							</div>
							<table class="table mt20px table-striped table-bordered" v-if="userInfo.isAdmin!='是'">
								<thead>
									<tr>
										<th v-for="thead in theadList">{{thead}}</th>
										<td></td>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(fileInfo,index) in roles" v-bind:key="index">
										<td>{{fileInfo.roleName}}</td>
										<td>{{fileInfo.isEnable}}</td>
										<td>{{fileInfo.grantorName}}</td>
										<td>{{fileInfo.grantTime}}</td>
										<td class="text-center">
											<a @click="goRoleDetail(index)">详情</a>
											<a v-show='isAdmin!=0' @click="tableRemove(fileInfo,index)">删除</a>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="form-group">
							<br />
							<label class="col-sm-1 control-label">创建人</label>
							<div class="col-sm-2">
								<input type="text" class="form-control" readonly v-model="userInfo.createName">
							</div>
							<label class="col-sm-1 control-label">创建时间</label>
							<div class="col-sm-2">
								<input type="text" class="form-control" readonly v-model="userInfo.createTime">
							</div>
							<label class="col-sm-1 control-label">修改人</label>
							<div class="col-sm-2">
								<input type="text" class="form-control" readonly v-model="userInfo.updateName">
							</div>
							<label class="col-sm-1 control-label">修改时间</label>
							<div class="col-sm-2">
								<input type="text" class="form-control" readonly v-model="userInfo.updateTime">
							</div>
						</div>
						<br /><br />
						<div class="col-sm-12 text-right">
							<button v-if="permission.indexOf('operator_childSave') == -1" class="btn btn-primary white" :disabled="!enableSubmit" @click="save()">保存</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--   添加权限组子页面开始    -->
		<sub-page :show="showSubPage" :bigTitleMsg="title" v-on:cancel="closeSubPage" :scroll='scrollTop'>
			<div slot="bodycontent">
				<add-authority-group 
					v-on:insertData="receive" v-on:onDetail="handleDetail"
					:data="noroles" >
				</add-authority-group>
			</div>
		</sub-page>
		<!--   添加权限组子页面结束    -->
		
		<!--   权限组详情子页面开始    -->
		<sub-page :show="showSubPageRole" 
				:bigTitleMsg="titleRole" 
				:scroll='scrollTop'
				v-on:cancel="closeSubPageRole">
				<div slot="bodycontent">
					<page-authority-edit
						:mode="roleMode"
						:data="roleDetail"
						:isShow="showSubPageRole"
						>
					</page-authority-edit>
				</div>
		</sub-page>
		<!--   权限组详情子页面结束    -->
		
		<!--   弹出框子组件        -->
		<tab-modal ref="modal1" size="small" title="提示" v-on:cancel="closeModal('modal1')">
			{{messageStr}}
			<div slot="footer">
		            <!--<button class="btn btn-primary">Say Hi</button>-->
		            <button @click="closeModal('modal1')" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
		
		<!--   弹出框子组件2        -->
		<tab-modal ref="modal2" size="small" title="提示" v-on:cancel="closeModal('modal2')">
			确定删除 {{userInfo.name}} 操作员？
			<div slot="footer">
		            <button @click="closeModal('modal2')" class="btn btn-primary">取消</button>
		            <button @click="remove" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
	</div>
</template>

<script>
	// ztree 相关
	import 'assets/plugins/ztree/css/metroStyle/metroStyle.css'
	import 'assets/plugins/ztree/js/jquery.ztree.core.js'
	import 'assets/plugins/ztree/js/jquery.ztree.excheck.js'
	import 'assets/plugins/ztree/js/jquery.ztree.exedit.js'
	import { queryTree } from 'util/util'
	// 其他子组件
	import SubPage from 'components/common/SubPage'
	import AddAuthorityGroup from 'components/pages/operator/AddAuthorityGroup'
	import PageAuthorityEdit from 'components/pages/authority/PageAuthorityEdit'
	import TabModal from 'components/common/TabModal'
	// vuelidate
	import { required, minLength, maxLength, between, email, sameAs } from 'vuelidate/lib/validators'
	import { OPERATE_SUCCESS, OPERATE_EXCEPTION } from 'static/message'
	import {INFO_STATUS} from 'static/constant'
	import classlist from 'util/classlist'
	export default {
		name: "PageOperator",
		components: {
			SubPage,
			AddAuthorityGroup,
			PageAuthorityEdit,
			TabModal
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["operator"]?this.$store.state.permission.permission["operator"]:[],
				loadingstatus:false,
				setting: {					// ztree的setting对象
					view: {
						fontCss: null
					},
					data: {
						simpleData: {
							enable: true
						},
						key:{
							name:'name'
						}
					},
					callback: {
						beforeClick: null
					}
				},
				isEmty:false,
				treeObj:null,
				errorVal:'',
				orgStatusInfo:INFO_STATUS,
				showSubPage: false,			// 显示添加权限组子页面
				showSubPageRole: false,		// 显示权限组详情子页面
				roleMode: 3,				// 权限组详情子页面模式为只读模式
				title: "添加权限组",
				titleRole: "权限组详情",
				roleIndex: 0,				// 权限组索引
				zNodes: [],
				theadList: ['权限组名', '状态', '授权人', '授权时间'],
				isEditOrCreate: true,		// 编辑或者新建  true: 新建，  false：编辑
				enableCreate: false,		// 创建按钮是否可用 true: 否，false: 是
				enableDelete: true,			// 删除按钮是否可用 true: 否，false: 是
				currentNode: null,			// 当前选中节点
				user: {						// 当前用户数据
					name: "栾帅"
				},
				userInfo: {					// 选中的用户数据
				},
				isAdmin:0,
				defaultUserInfo: {			// 默认用户数据
					crate_name: "",
					create_time: "",
					id: "",
					isAdmin: "否",
					isenable: "1",
					job: "",
					memo: "",
					mobile: "",
					name: "",
					update_name: "",
					update_time: "",
					customer_name: "",
					orderno: "",
					
					// 新增
					account: "",			// 帐号
					password: "",			// 密码
					passwordConfirm: ""
				},
				roles: [],					// 所属权限组
				noroles: [],				// 非所属权限组
				scrollTop: '',
				roleDetail: {},				// 权限组详情
				messageStr: "",				// 弹出框提醒内容
				savedId: '',
				mailLink:'',            //根据邮箱类型给出不同跳转链接
				normalMail:false,       //是否是非163  sina qq邮箱以外的邮箱
				queryAccount:''
			}
		},
		computed: {
			/*qqMail:function(){
				const indexAt = this.userInfo.account.indexOf('@');
				const indexDot = this.userInfo.account.indexOf('.')
				const qqStr = this.userInfo.account.substring(indexAt + 1,indexDot)
				if(qqStr === 'qq' || qqStr === 'QQ'){
					return false
				}else{
					return true
				}
			},*/
			enableSubmit: function(){//&& this.qqMail
				let passwordAbout = true;
				// 编辑状态非必填项
				if(this.isEditOrCreate){
					passwordAbout = this.$v.userInfo.password.required 
					&& this.$v.userInfo.password.minLength && this.$v.userInfo.password.maxLength
					&& this.$v.userInfo.passwordConfirm.sameAsPassword;
//					console.log(passwordAbout);
				}
				return this.$v.userInfo.name.required && this.$v.userInfo.orderno.required 
					&& this.$v.userInfo.account.required
					&& this.$v.userInfo.memo.maxLength && this.$v.userInfo.orderno.between && this.isAdmin>0
					&& passwordAbout;
					//					&& this.$v.userInfo.account.required && this.$v.userInfo.account.email 
			}
		},
		validations: {
		    userInfo: {
		    	name: {
		    		required
		    	},
		    	orderno: {
		    		required,
		    		between: between(0, 100000)
		    	},
		    	account: {
		    		required,
		    		email
		    	},
		    	memo: {
		      		maxLength: maxLength(300)
		    	},
		    	account: {
		    		required
		    	},
		    	password: {
		    		required,
		    		maxLength: maxLength(30),
		    		minLength: minLength(6)
		    	},
		    	passwordConfirm: {
		    		sameAsPassword: sameAs('password')
		    	},
		    }
//	    	validationGroup: ['userInfo.name','userInfo.orderno','userInfo.account','userInfo.memo','userInfo.userName','userInfo.password','userInfo.passwordConfirm']
		},
		watch: {
			queryAccount(val){
				let name = this.setting.data.key.name || 'name'
				if(val){
					let nodeList = queryTree(this.treeObj,val,name)
					if(nodeList.length == 0){
						this.isEmty = true
						this.errorVal = val
					}else{
						this.isEmty = false
					}
				    this.setting.data.simpleData.enable = false;
					$.fn.zTree.init($('#operator-tree'),this.setting,nodeList)
				 	$.fn.zTree.getZTreeObj('operator-tree').expandAll(false)
				}else{
					this.isEmty = false
					this.setting.data.simpleData.enable = true;
					$.fn.zTree.init($('#operator-tree'), this.setting, this.zNodes); 
				}
			},
			// 当更改数据时，更新界面
			'zNodes.length' (val) {
				this.init();
			},
//			'userInfo.account'(val){
//				let str = val.substring(val.indexOf('@'))
//				if(/(@163.com)$/.test(str) || /(@126.com)$/.test(str)){
//					this.normalMail = false
//					this.mailLink = 'http://help.mail.163.com/faqDetail.do?code=d7a5dc8471cd0c0e8b4b8f4f8e49998b374173cfe9171305fa1ce630d7f67ac28e86c6b6ec2acd66'
//					return
//				}else if(/(@sina.com)$/.test(str)){
//					this.normalMail = false
//					this.mailLink = 'http://mail.sina.com.cn/help2/2008-08-02-86.html'
//					return
//				}else if(/(@qq.com)$/.test(str)){
//					this.normalMail = false
//					this.mailLink = 'http://service.mail.qq.com/cgi-bin/help?subtype=1&no=113&id=16'
//					return
//				}else{
//					this.normalMail = true
//					this.mailLink = 'javascript(void)'
//					return
//				}
//			}
		},
		mounted() {
			this.init();
		},
		created(){
			this.isAdmin = this.$store.state.user.admin;
		},
		beforeMount() {
			this.userInfo = Object.assign({}, this.defaultUserInfo);
//			this.$http.get('../../../static/operator/accounts_tree.json')
			this.initTreeData();
		},
		methods: {
			// 初始化ztree
			init() {
				const { setting, beforeClick, getFont } = this;
				setting.callback.beforeClick = beforeClick;					// 设置点击事件
				setting.view.fontCss = getFont;								// 设置禁用的管理员灰掉
				$.fn.zTree.init($("#operator-tree"), setting, this.zNodes); // 初始化管理员树
				this.$nextTick(() => {
					this.treeObj = $.fn.zTree.getZTreeObj("operator-tree").getNodes();
				})
			},
			// 请求管理员树的数据
			initTreeData() {
				var count = 100000;
				var self = this;
				this.$http.get(process.env.API_ROOT + '/account/accounts')
				.then((res) => {
					if(!res.data.success){
						self.messageStr = res.data.message;
						this.openModal('modal1');
						return;
					}
					this.showTable = true;
					var treeList = res.data.data;
					treeList.map((node) => {
						// 根据type区分是分组结点还是叶子结点
						if(node.type === "0"){ 
							node.isParent = true;
							if(node.pId == '0')
								node.open = true;			// 默认打开树的第一层
						} else { 
							//判断是否是管理员
							if(node.isAdmin == 0){ //普通操作员
								node.iconSkin = 'icon03'
							}else if(node.isAdmin == 1){ //普通管理员
								node.iconSkin = 'icon02'
							}else if(node.isAdmin == 9){//超级管理员
								node.iconSkin = 'icon01'
							}else{
								return
							}							
							node.isParent = false;
							// 避免操作员id与组织机构id重合问题，原因为此二者不是一张表，所以有重合的可能性
							node.uid = node.id;
							node.id = count++;
						}
						// 判断是否禁用，如果禁用，则灰掉
						if(node.isenable === 0){
							node.font = { 'color': 'gray' };
						}
						
						return node;
					});
					this.zNodes = treeList;
					this.currentNode = this.zNodes[0];		// 设置根节点为当前节点
					// 若是新建状态则重置userInfo信息
					if(this.isEditOrCreate){
						this.create();
					}
				}, (res) => {
					this.openModal1(res.data.message);
				}).catch( res => {
					this.openModal1(OPERATE_EXCEPTION);
				});
			},
			// 点击节点前的回调
			beforeClick(treeId, treeNode, clickFlag) {
				//return false;
				this.currentNode = treeNode;
				// 若点击父节点，则转为新建操作员状态，否则获取点击的操作员的信息
				if(treeNode.isParent) {
					this.enableCreate = false;
					this.enableDelete = true;
					this.create();
				} else {				
					this.isEditOrCreate = false;
					this.enableCreate = true;
					this.enableDelete = false;
					this.getOperatorInfo();
					this.getOperatorRoles();
				}
				this.$v.userInfo.$reset();
			},
			// 获取操作员信息
			getOperatorInfo(id){
				var self = this;
				id = id || this.currentNode.uid;
				this.$http.get(process.env.API_ROOT + '/account/accounts/' + id)
				.then((res) => {
					if(!res.data.success){
						self.messageStr = res.data.message;
						this.openModal('modal1');
						return;	
					}
					var userTmp = res.data.data;
					if(userTmp.isAdmin == 1 ||userTmp.isAdmin == 9){
						userTmp.isAdmin = "是";
					} else if (userTmp.isAdmin == 0){
						userTmp.isAdmin = "否";
					}
					userTmp.passwordConfirm = ''
					userTmp.account = userTmp.account.split("@")[0];
					this.userInfo = userTmp;
					this.userInfo.customer_name = this.currentNode.getParentNode ? this.currentNode.getParentNode().name : this.currentNode.name;
					this.userInfo.customer_short_name = this.currentNode.getParentNode ? this.currentNode.getParentNode().shortName : this.currentNode.shortName;
				}, (res) => {
					this.openModal1(res.data.message || OPERATE_EXCEPTION);
				}).catch( res => {
					this.openModal1(OPERATE_EXCEPTION);
				});
			},
			// 获取操作员权限组
			getOperatorRoles(id){
				id = id || this.currentNode.uid;	
				this.$http.get(process.env.API_ROOT + '/account/accounts/' + id + '/roles')
				.then( res => {
					if(!res.data.success){
						return;	
					}
					var roles = res.data.data;
					roles = roles.map( role => {
						if(role.isEnable == 1){
							role.isEnable = INFO_STATUS[0].name;
						} else {
							role.isEnable = INFO_STATUS[1].name;
						}
						return role;
					})
					this.roles = roles;
				}, (res) => {
					this.openModal1(res.data.message || OPERATE_EXCEPTION);
				}).catch( res => {
					this.openModal1(OPERATE_EXCEPTION);
				});
			},
			// 获取操作员未授权权限组
			getOperatorNoRoles(){
				var type = 0;	// 新建
				var id = this.currentNode.id;
				if(this.enableCreate){
					// 编辑
					type = 1;
					id = this.userInfo.id;
				}
				if(!id) return;
				this.$http.get(process.env.API_ROOT + '/account/accounts/' + id + '/no-roles?type=' + type)
				.then( res => {
					if(!res.data.success) return;
					var roles = res.data.data;
					roles = roles.map( role => {
						if(role.isEnable == 1){
							role.isEnable = INFO_STATUS[0].name;
						} else {
							role.isEnable = INFO_STATUS[1].name;
						}
						role.isChecked = false;
						return role;
					})
					if (this.roles.length>0){
						this.roles.forEach(function(item, i) {
							let index = roles.findIndex(function(value, index, arr) {
							   return value.id == item.roleId;
							})
							if (index!==-1){
								roles.splice(index,1)
							}
						})
					}
					this.noroles = roles;
					
				}, (res) => {
					this.openModal1(res.data.message || OPERATE_EXCEPTION);
				}).catch( res => {
					this.openModal1(OPERATE_EXCEPTION);
				});
			},
			// 点击新建按钮
			create() {
				const { user, currentNode } = this;
				var { userInfo, defaultUserInfo } = this;
				// 清空数据
				this.userInfo = Object.assign({}, defaultUserInfo);
				this.userInfo.customer_name = currentNode.name;
				this.userInfo.customer_short_name = currentNode.shortName;
				this.roles = [];
				this.isEditOrCreate = true;
				this.$v.userInfo.$reset();
			},
			// 点击删除按钮
			remove() {
				this.closeModal('modal2');
				this.$http.delete(process.env.API_ROOT + "/account/accounts/"+ this.currentNode.uid)
				.then( res => {
					if(res.data.success){
						// 重置vuelidate的状态
						this.$v.userInfo.$reset();
						this.openModal1(OPERATE_SUCCESS);
						// 在操作员树中删除对应数据
						var id = this.currentNode.id;
						this.zNodes.forEach((nodeVal, index) => {
							if(nodeVal.id === id) {
								this.zNodes.splice(index, 1);
								this.currentNode = this.currentNode.getParentNode();
								this.create();
								return;
							}
						})
					} else {
						this.openModal1(res.data.message);
					}
				}, res=> {
					this.openModal1(res.data.message || OPERATE_EXCEPTION);
				}).catch( res => {
					this.openModal1(OPERATE_EXCEPTION);
				});
			},
			getFont(treeId, node) {
				return node.font ? node.font : {};
			},
			tableRemove(fileInfo,index) {
				this.roles[index].isChecked = false;
				this.noroles.push(this.roles[index]);
				this.roles.splice(index,1);
			},
			// 点击保存按钮
			save(){
				this.loadingstatus = true;
				const { currentNode, userInfo, roles, deepcopy, initTreeData, openModal1 } = this;
				if(!this.enableCreate){
					// 新建
					var userTmp = this.deepcopy(userInfo);
					if(userTmp.isAdmin == '是') userTmp.isAdmin = '1';
					else userTmp.isAdmin = '0';
					var rolesTmp = [];
					roles.forEach( item => {
						rolesTmp.push({roleId:item.roleId?item.roleId:item.id});
					})
					userTmp.roleList = rolesTmp;
					userTmp.customerId = this.currentNode.id;
					userTmp.account = userTmp.account + '@' + userTmp.customer_short_name;
					this.$http.post(process.env.API_ROOT + '/account/accounts/', userTmp)
						.then(res => {
							if(res.data.success){
								this.openModal1(OPERATE_SUCCESS);
								initTreeData();
								this.savedId = res.data.data;
								this.getOperatorInfo(res.data.data);
								this.getOperatorRoles(res.data.data);
								// 转入编辑状态
								this.isEditOrCreate = false;
								this.enableCreate = true;
								this.$v.userInfo.$reset();
								if (this.$store.state.user.userId==userTmp.id){
									this.$store.dispatch('setusername',userTmp.name);
								}
								// this.userInfo = this.deepcopy(this.defaultUserInfo);
							} else {
								this.openModal1(res.data.message);								
							}
							this.loadingstatus = false;
						}, res => {
							this.openModal1(res.data.message || OPERATE_EXCEPTION);
							this.loadingstatus = false;
						})
//						.catch( res => {
//							console.log(res.message);
//							this.loadingstatus = false;
//						});
				} else {
					// 编辑
					var userTmp = this.deepcopy(userInfo);
					delete userTmp.lastLoginTime;
					if(userTmp.isAdmin == '是') userTmp.isAdmin = '1';
					else userTmp.isAdmin = '0';
					
					var rolesTmp = [];
					roles.forEach( item => {
						rolesTmp.push({roleId:item.roleId?item.roleId:item.id});
					})
					userTmp.roleList = rolesTmp;
					userTmp.account = userTmp.account + '@' + userTmp.customer_short_name;
					var id = this.currentNode.uid || this.savedId;
					this.$http.put(process.env.API_ROOT + '/account/accounts/' + id, userTmp)
						.then(res => {
							if(res.data.success){
								this.openModal1(OPERATE_SUCCESS);
								this.getOperatorInfo(id);
								this.getOperatorRoles(id);
								this.$v.userInfo.$reset();
								this.refreshNode();
								if (this.$store.state.user.userId==userTmp.id){
									this.$store.dispatch('setusername',userTmp.name);
								}
							}
							this.loadingstatus = false;
						}, res => {
							this.openModal1(res.data.message || OPERATE_EXCEPTION);
							this.loadingstatus = false;
						}).catch( res => {
							console.log(res.message);
							this.loadingstatus = false;
						});
				}
			},
			refreshNode(){
				 var zTree = $.fn.zTree.getZTreeObj("operator-tree"),
				 nodes = zTree.getSelectedNodes(),
		         treeNode = nodes[0];
		         treeNode.name = this.userInfo.name;
		         zTree.updateNode(treeNode, false);
			},
			// 点击权限组详情
			goRoleDetail(index) {
				// 获取权限组详情
				var id = this.roles[index].roleId?this.roles[index].roleId:this.roles[index].id;
				this.$http.get(process.env.API_ROOT + "/account/roles/" + id)
				.then( res => {
					if(res.data.success){
						var roleTmp = res.data.data;
						if(roleTmp.isEnable == '1')
							roleTmp.isEnable = INFO_STATUS[0].name;
						else roleTmp.isEnable = INFO_STATUS[1].name;
						this.roleDetail = roleTmp;
						this.showSubPageRole = true;
						this.roleIndex = index;
						this.fixUI();
					} else {
						this.openModal1(res.data.message);
					}
				}, res => {
					this.openModal1(res.data.message || OPERATE_EXCEPTION);
				}).catch( res => {
					this.openModal1(OPERATE_EXCEPTION);
				});
			},
			// 点击 添加权限组 -> 详情
			handleDetail(index){
				this.$http.get(process.env.API_ROOT + "/account/roles/" + this.noroles[index].id)
				.then( res => {
					if(res.data.success){
						var roleTmp = res.data.data;
						if(roleTmp.isEnable == '1')
							roleTmp.isEnable = INFO_STATUS[0].name;
						else roleTmp.isEnable = INFO_STATUS[1].name;
						this.roleDetail = roleTmp;
						this.showSubPageRole = true;
						this.roleIndex = index;
						this.fixUI();
					} else {
						this.openModal1(res.data.message);
					}
				}, res => {
					this.openModal1(res.data.message);
				}).catch( res => {
					this.openModal1(OPERATE_EXCEPTION);
				});
			},
			addAuthorization(){//添加权限组
				this.showSubPage = true;
				this.fixUI();
				this.getOperatorNoRoles();
			},
			closeSubPage(){//取消添加权限组弹框
				this.showSubPage = false;
                classlist.toggleScroll('open','#operator',this);
			},
			closeSubPageRole(){//取消弹框
				this.showSubPageRole = false;
				classlist.toggleScroll('open','#operator',this);
			},
			// 点击 添加权限组 -> 确定
			receive(){
				this.closeSubPage()
				var norolesTmp = [];
				this.noroles.forEach((role, index) => {
					if(role.isChecked) {
						role.grantorName = this.$store.state.user.username;
						role.grantTime = this.dateFormat(new Date());
						this.roles.push(role);
					} else {
						norolesTmp.push(role);
					}
				})
				this.noroles = norolesTmp;
			},
			// 点击 通过邮箱重置密码
			mailboxReset(){
				const { userInfo } = this;
				this.$http.post(process.env.API_ROOT + "/account/accounts/password?userId="+userInfo.id)
				.then( res => {
					if(res.data.success){
						this.openModal1(OPERATE_SUCCESS);
					} else {
						this.openModal1(res.data.message);
					}
				},res => {
					this.openModal1(res.data.message || OPERATE_EXCEPTION);
				}).catch( res => {
					this.openModal1(OPERATE_EXCEPTION);
				});
			},
			// 时间格式化
			dateFormat(date){
				return new Array(date.getFullYear(),date.getMonth()<9?'0'+(date.getMonth()+1):date.getMonth()+1,date.getDate()<10?'0'+date.getDate():date.getDate()).join("-") + " "
				+ new Array(date.getHours()<10?'0'+date.getHours():date.getHours(),date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes(),date.getSeconds()<10?'0'+date.getSeconds():date.getSeconds()).join(":");
			},
			fixUI(){
				classlist.toggleScroll('close','#operator',this);
			},
			goTab(){
				const obj = {
					name:'权限组管理',
					id:'PageAuthorityList',
					route:'/indexhome/authorityList',
					No:'authorityList'
				}
				this.$router.push({path:'/indexhome/authorityList'});
				this.$store.dispatch('addTab',obj);
			},
			// 深复制
			deepcopy(source) {
				var result={};
				for (var key in source) {
					result[key] = typeof source[key]==='object'? this.deepcopy(source[key]): source[key];
				} 
			   	return result; 
			},
			// 消息弹出框相关 ==============================
			openModal(ref) {
            	this.$refs[ref].open();
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        	},
        	openModal1(message){
        		this.messageStr = message;
        		this.openModal("modal1")
        	}
		}
	}
</script>

<style scoped>
.t_left {
    text-align: left !important;
}

</style>


// WEBPACK FOOTER //
// PageOperator.vue?eef6e282